import GeneratedProductListPanel from './generatedProductListPanel.container';

export default GeneratedProductListPanel